var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeaderSuccess = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 88,
    style: {
      background: "#fff"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h180v88H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EFF",
    fillOpacity: 0.05,
    d: "M98.792 15c3.21 0 5.812 2.597 5.812 5.8s-2.602 5.8-5.812 5.8h53.133c3.209 0 5.81 2.597 5.81 5.8s-2.601 5.8-5.81 5.8h18.264c3.21 0 5.811 2.597 5.811 5.8s-2.602 5.8-5.811 5.8h-15.774c-3.21 0-5.811 2.597-5.811 5.8s2.602 5.8 5.811 5.8h4.981c3.21 0 5.812 2.597 5.812 5.8s-2.602 5.8-5.812 5.8h-43.17a5.87 5.87 0 0 1-1.245-.133 5.87 5.87 0 0 1-1.245.133H38.189c-3.21 0-5.812-2.597-5.812-5.8s2.602-5.8 5.812-5.8H5.81C2.601 61.4 0 58.803 0 55.6s2.602-5.8 5.811-5.8H39.02c3.21 0 5.811-2.597 5.811-5.8s-2.602-5.8-5.811-5.8H18.264c-3.21 0-5.811-2.597-5.811-5.8s2.602-5.8 5.811-5.8h33.208c-3.21 0-5.812-2.597-5.812-5.8s2.602-5.8 5.812-5.8h47.32zM174 60a6 6 0 1 1 0 12 6 6 0 0 1 0-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#009EFF",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M113.013 71.762c2.13-1.37 4.022-3.079 5.253-4.459m1.988-2.293h0a33.383 33.383 0 0 0 6.608-13.353 33.864 33.864 0 0 0-.93-18.927 33.526 33.526 0 0 0-4.094-8.09 34.032 34.032 0 0 0-3.546-4.33 33.906 33.906 0 0 0-6.322-5.146 33.57 33.57 0 0 0-7.672-3.575 33.803 33.803 0 0 0-10.284-1.61 33.745 33.745 0 0 0-8.045.96 33.383 33.383 0 0 0-15.318 8.456 33.47 33.47 0 0 0-6.326 8.383 33.45 33.45 0 0 0-3.307 9.369 33.886 33.886 0 0 0-.408 10.13 33.683 33.683 0 0 0 9.292 19.762 33.762 33.762 0 0 0 11.454 7.794 33.838 33.838 0 0 0 16.011 2.39 33.453 33.453 0 0 0 13.108-4.035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.767 1.708v4.204m0 5.606v4.205m-7.007-7.008h4.204m5.606 0h4.204M65.606 73.883v2.803m0 5.606v2.803M60 79.489h2.803m5.605-.001h2.803",
    stroke: "#009EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#009EFF",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M83.8 16.112a29.054 29.054 0 0 0-4.173 1.954 29.358 29.358 0 0 0-5.889 4.413 29.684 29.684 0 0 0-2.091 2.239m-2.015 2.693a29.155 29.155 0 0 0-2.325 4.243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2FAFF",
    fillRule: "nonzero",
    stroke: "#009EFF",
    strokeWidth: 2.5,
    d: "M80.855 43.207a2.527 2.527 0 0 0-3.536.158 2.444 2.444 0 0 0 .16 3.486l11.778 10.61a3.54 3.54 0 0 0 4.95-.22c.054-.06.054-.06.107-.122l16.808-19.935c.884-1.048.739-2.604-.324-3.475s-2.64-.728-3.524.32L91.47 52.77l-10.616-9.563z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/header-success.bef5027e2fed85f207b6abae980c9b6d.svg";